import { addMilliseconds, Duration, intervalToDuration } from 'date-fns';
import { component, Component, ComponentPolicy, DateType, property } from '../../../concepts/objects';
import { ServerDate } from '../../../platform/ServerDate';
import { Audited } from '../../packages/auditing/Audited';

const meetingDef = {
    name: 'Meeting',
    implements: [Audited],
    // mutation: meetingMutate,
    // propertyLayout: meetingPropertyLayout,
};

const meetingPolicy = ComponentPolicy.create({
    allowAdd: (child) => child.type === 'Phase' ? [true] : [false, 'Meeting can only have Phase children.']
});

const durationFromMs = (ms: number) => {
    const start = new Date();
    const end = addMilliseconds(start, ms);
    return intervalToDuration({ start, end });
};

export type MeetingMode = 'structured' | 'freestyle';

@component(meetingDef)
export class Meeting extends Component implements Audited {

    protected get policy() {
        return meetingPolicy;
    }

    @property({ type: 'string' })
    public boardId!: string;

    @property({ type: 'string' })
    public userId!: string;

    @property({ type: DateType })
    public created!: Date;

    @property({ type: 'string', default: 'structured' })
    public mode!: MeetingMode;

    @property({ type: 'number' })
    public activePhase!: number;

    @property({ type: 'string[]' })
    public facilitators!: string[];

    @property({ type: 'string' })
    public welcome!: string;

    @property({ type: 'number', default: 0 })
    public breakStart!: number;

    @property({ type: 'number', default: 0 })
    public breakLength!: number;

    @property({ type: 'boolean' })
    public startLocked!: boolean;

    @property({ type: 'boolean' })
    public timer!: boolean;

    @property({ type: 'number' })
    public timeBank!: number;

    @property({ type: 'number' })
    public timeStarted!: number;

    @property({ type: 'number' })
    public timePaused!: number;

    public getTimeReading(): Duration {

        if (!this.timeBank) {
            return durationFromMs(0);
        }

        if (!this.timeStarted && !this.timePaused) {
            return durationFromMs(this.timeBank);
        }

        const now = this.timePaused || ServerDate.now();
        const remaining = this.timeBank - (now - (this.timeStarted || this.timePaused));

        const start = new Date(this.timeStarted ?? this.timePaused);
        const end = addMilliseconds(start, remaining);

        if (start < end) {
            return intervalToDuration({ start, end });
        }
        else {
            return durationFromMs(0);
        }
    }

    public getTimeReadingMs() {
        const { hours, minutes, seconds } = this.getTimeReading();
        return ((hours * 60 * 60) + (minutes * 60) + seconds) * 1000;
    }

    public getTimeReadingFormatted() {
        const { hours, minutes, seconds } = this.getTimeReading();
        const m = minutes + (hours * 60);
        const s = seconds;
        return [m, s].map(x => x.toString().padStart(2, '0')).join(':');
    }
}
